import { Done } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

type ResolveAllButtonProps = {
  markAllMentionsResolved: () => void
}

export const ResolveAllButton = ({ markAllMentionsResolved }: ResolveAllButtonProps) => {
  const { t } = useTranslation('dashboard')
  return (
    <Button variant="text" color="primary" onClick={markAllMentionsResolved} startIcon={<Done sx={{ fontSize: '20px' }} />}>
      {t('mentions.mark-all-resolved')}
    </Button>
  )
}
